import { requestPublicJson } from './api.js';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, String(value));
  });
  const text = query.toString();
  return text ? `?${text}` : '';
}

export async function fetchBlogPosts(params = {}) {
  const payload = await requestPublicJson(`/api/content/publications${buildQuery(params)}`);
  return {
    documents: Array.isArray(payload?.documents) ? payload.documents : [],
    total: Number(payload?.total || 0),
    page: Number(payload?.page || 1),
    pageSize: Number(payload?.pageSize || 20),
  };
}

export async function fetchBlogPost(slug) {
  const payload = await requestPublicJson(`/api/content/publications/${encodeURIComponent(slug)}`);
  return payload?.document ? { ...payload.document, isPreview: Boolean(payload.preview) } : null;
}

export async function fetchBlogCategory(slug, params = {}) {
  const payload = await requestPublicJson(`/api/content/publications${buildQuery({ ...params, categorySlug: slug })}`);
  return {
    category: payload?.category || null,
    documents: Array.isArray(payload?.documents) ? payload.documents : [],
    total: Number(payload?.total || 0),
    page: Number(payload?.page || 1),
    pageSize: Number(payload?.pageSize || 20),
  };
}
